import { Products } from "src/types/ClientDetails";

export const checkSubscription = (
  clients: any,
  selectedClient: string,
  selectedProduct: string
) => {
  if (selectedClient && selectedProduct) {
    const client = clients?.find(
      (client: any) => client.clientCode === selectedClient
    );
    if (client) {
      return client.products?.some(
        (product: Products) => product.productName === selectedProduct
      );
    }
  }
  return false;
};

export const highlightText = (text: string) => {
  let list = text.split(" ");
  return list.map((el, index) => {
    return (
      <span key={"span" + index}>
        {el.match(/{string}/) ? (
          <span
            style={{
              color: "#ef6935",
              padding: "0 2px",
            }}
          >
            {`{string}`}
          </span>
        ) : el.match(/{word}/) ? (
          <span
            style={{
              color: "#ef6935",
              padding: "0 2px",
            }}
          >
            {`{word}`}
          </span>
        ) : el.match(/{int}/) ? (
          <span
            style={{
              color: "#ef6935",
              padding: "0 2px",
            }}
          >
            {`{int}`}
          </span>
        ) : (
          <span
            style={{
              padding: "0 2px",
            }}
          >
            {el}
          </span>
        )}
      </span>
    );
  });
};
